import React from "react";

import {
  Box,
  Button,
  Stack,
  Typography,
} from "@braintrust/braintrust-ui-components";
import { useUser } from "@js/apps/common/hooks/use-user";
import { openRecreateOTPAuthBackupCodesModal } from "@js/apps/settings/components/otp-auth/recreate-otp-backup-codes-modal";
import { openRecreateOTPAuthModal } from "@js/apps/settings/components/otp-auth/recreate-otp-modal";
import { Section } from "@js/apps/settings/forms/helpers";

import { PasskeySection } from "../../passkey-auth";
import {
  DisableOTPAuthModal,
  RecreateOTPAuthBackupCodesModal,
  RecreateOTPAuthModal,
  ToggleOTPSwitch,
} from "../index";

export const OTPAuthSection = () => {
  const user = useUser();
  const isOTPEnabled = user?.is_otp_enabled;
  const canDisableOTP = user?.can_disable_otp?.value;

  return (
    <Section title="Two-factor authentication">
      <Stack sx={{ mt: -1 }}>
        <Stack>
          <Stack
            direction="row"
            sx={{
              gap: 2,
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="label" size="large" component="h4">
              Authenticator app
            </Typography>
            <ToggleOTPSwitch
              isOTPEnabled={!!isOTPEnabled}
              canDisableOTP={!!canDisableOTP}
            />
          </Stack>
          <Typography
            component="p"
            color="secondary"
            sx={{ maxWidth: "500px" }}
          >
            Use an authenticator app to generate a verification code whenever
            you sign in or confirm sensitive actions.
          </Typography>
        </Stack>
        {isOTPEnabled && (
          <Stack
            direction="row"
            sx={{ ml: { sm: "auto" }, gap: 1, flexWrap: "wrap", mt: 2 }}
          >
            <Button variant="secondary" onClick={openRecreateOTPAuthModal}>
              Change 2FA App
            </Button>
            <Button
              variant="secondary"
              onClick={openRecreateOTPAuthBackupCodesModal}
            >
              Recreate 2FA Backup Codes
            </Button>
          </Stack>
        )}
        <Box sx={{ mt: { xs: 3, sm: 8, mt: 10 } }}>
          <PasskeySection />
        </Box>
      </Stack>

      <DisableOTPAuthModal />
      <RecreateOTPAuthModal />
      <RecreateOTPAuthBackupCodesModal />
    </Section>
  );
};
